// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

/* eslint-disable spire/export-styles */
import { GetBillTosApiParameter, GetShipTosApiParameter } from "@insite/client-framework/Services/CustomersService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import AddressesSelectCustomerContainer from "@insite/content-library/Widgets/Header/AddressDrawerSelectCustomerContainer";
import React from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => {
    const { isAuthenticated, isGuest } = getSession(state);
    return {
        showAddressesSelector: isAuthenticated && !isGuest,
        billToId: state.components.addressDrawer.selectedBillTo?.id,
    };
};

type Props = ReturnType<typeof mapStateToProps>;

const AddressDrawerSelectCustomer = ({ showAddressesSelector, billToId }: Props) => {
    const [billTosParameter, setBillTosParameter] = React.useState<GetBillTosApiParameter>({
        page: 1,
        pageSize: 20,
        // XNG-Changes: CES-859: removing shipTos from billTo expand
        // expand: ["shipTos"],
    });
    const [shipTosParameter, setShipTosParameter] = React.useState<GetShipTosApiParameter>({
        billToId,
        page: 1,
        pageSize: 20,
        expand: ["validation", "excludeShowAll", "excludeOneTime", "excludeCreateNew"],
    });

    const temp = (parameter: GetShipTosApiParameter) => {
        setShipTosParameter(parameter);
    };

    if (!showAddressesSelector) {
        return null;
    }

    return (
        <AddressesSelectCustomerContainer
            billTosParameter={billTosParameter}
            setBillTosParameter={setBillTosParameter}
            shipTosParameter={shipTosParameter}
            setShipTosParameter={temp}
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(AddressDrawerSelectCustomer),
    definition: {
        displayName: "Customer Selector",
        icon: "users",
        fieldDefinitions: [],
        group: "Header",
    },
};

export default widgetModule;
